<template>
	<section class="view-feed-trainer">
		<header>
			<h6 class="h7">Test Open Trainer</h6>
		</header>

		<section class="padded">
			<!-- <img src="https://pad.chalkysticks.com/3359e.svg" /> -->
			<!-- <img src="https://api-v3.chalkysticks.com/v3/diagrams/486ce/svg" /> -->
			<!-- <img src="https://api-v3.chalkysticks.com/v3/diagrams/e7ca8fe/svg" /> -->
			<img v-bind:src="'https://api-v3.chalkysticks.com/v3/diagrams/' + diagramId + '/svg'" />
		</section>

		<section class="padded">
			<p>
				Test our you skills against other players. How would you shoot this pattern? Lorem ipsum dolor sit amet
				adipiscing elit et al.
			</p>

			<button v-on:click="Handle_OnClickOpen">Open</button>
		</section>

		<section v-if="open" class="diagram-modal">
			<header>
				<button
					id="btnClose"
					class="control round size-medium type-close background-transparent filter-invert"
					v-on:click="Handle_OnClickClose"
				>
					Close
				</button>
			</header>

			<ChalkyTrainerSceneGame
				ref="table"
				v-bind:ambientSound="true"
				v-bind:autoActivate="false"
				v-bind:autoStartAmbient="false"
				v-bind:autoStartMusic="false"
				v-bind:backgroundMusic="false"
				v-bind:debugMode="false"
				v-bind:diagramId="diagramId"
				v-bind:diagramInverse="diagramInverse"
				v-bind:environment="'AmsterdamBilliards'"
				v-bind:showEnglishMeter="true"
				v-bind:showFpsCounter="false"
				v-bind:showPowerMeter="true"
				v-bind:soundEnabled="true"
				v-bind:startInLowPower="false"
				v-bind:tableAppearance="'Traditional'"
				v-on:game:ready="Handle_OnGameReady"
			/>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedTrainer extends ViewBase {
		/**
		 * Diagram ID to load
		 *
		 * @type string
		 */
		protected diagramId: string = '8d6ff60';

		/**
		 * If we should rotate the diagram
		 *
		 * @type string
		 */
		protected diagramInverse: boolean = true;

		/**
		 * Whether the Trainer view is open
		 *
		 * @type boolean
		 */
		protected open: boolean = false;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickClose(e: Event): Promise<void> {
			e.preventDefault();

			this.open = false;
		}

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickOpen(e: Event): Promise<void> {
			e.preventDefault();

			this.open = true;
		}

		/**
		 * Shuffle balls on load
		 *
		 * @return Promise<void>
		 */
		protected async Handle_OnGameReady(): Promise<void> {
			ChalkySticks.Core.Event.Bus.dispatch('game.control:shuffle');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-trainer {
		padding: 2em 0;
		text-align: center;

		.diagram-modal {
			bottom: 70px;
			left: 0;
			position: fixed;
			top: 0;
			width: 100%;
			z-index: var(--z-modal-bottom);

			header {
				display: flex;
				justify-content: flex-end;
				padding: 1rem;
				position: absolute;
				width: 100%;
				z-index: 20;
			}

			.scene-game {
				height: 100%;
				width: 100%;
			}
		}
	}
</style>
